import React from "react";
import { UpgradeRack } from "../station/racks";
import { BenchDive } from "../../scenes/bench/BenchDive";
import { useGame, useShellVersion } from "../../useShell";
import { useBenchChrome } from "./useBenchDive";

/**
 * A worktable's upgrade slots, folded into a small pull above the shelf
 * tray in the bottom-left corner. What's literally under the bench top
 * is otherwise on the canvas: the shelf is the tray itself
 * (BenchTrayView), and pieces go on and off it by hand. A table with no
 * upgrade slots renders nothing — the bench view owes it no paperwork.
 */
export const UnderBenchPanel: React.FC = () => {
  const game = useGame();
  useShellVersion();
  const chrome = useBenchChrome();
  const bench = game.entities.tryGetSingleton(BenchDive)?.openBench();
  if (!bench) return null;

  const machine = bench.view();
  if ((machine.type.upgradeSlots ?? 0) === 0) return null;

  return (
    <details
      // Bottom-left, just above the shelf tray's ledge; the card opens
      // up from the pull
      className={`pointer-events-auto absolute bottom-[76px] left-5 z-40 w-80 max-w-[80vw] ${chrome.className}`}
      data-testid="under-bench"
      inert={chrome.inert}
    >
      <summary className="inline-block cursor-pointer select-none rounded bg-ink-black/70 px-2.5 py-1.5 font-condensed uppercase tracking-[0.15em] text-[0.65rem] text-paper-manila/80 shadow-lg hover:text-paper-manila">
        Upgrades
      </summary>
      <div className="paper-card mt-1.5 max-h-[45vh] overflow-y-auto text-left shadow-xl">
        <UpgradeRack machine={machine} />
      </div>
    </details>
  );
};
